import { createSlice } from '@reduxjs/toolkit';

export const Incentive = createSlice({
  name: 'incentiveNext',
  initialState: {
    refId: '123412',
    recentCoupon: null,
  },
  reducers: {
    incentiveNext: (state, action) => {
      state.refId = action.payload.refId;
    },
    setRecentCoupon: (state, action) => {
      try {
        const couponData = action.payload?.data
          ? JSON.parse(action.payload.data)
          : [];
        const latestCoupon =
          couponData
            .find((coupon) => coupon.latest)
            ?.offerDescription?.split(' ')[0] || null;
        state.recentCoupon = latestCoupon;
      } catch (e) {
        state.recentCoupon = null;
      }
    },
  },
});
export const { incentiveNext, setRecentCoupon } = Incentive.actions;

export default Incentive.reducer;
